/**
 * Mapping of URL token names (e.g. from /checkout/:tokenName) to token address.
 * Token metadata (symbol, logoURI, giftCardImages, etc.) is loaded from RTX/DB via searchTokens.
 */
export const CHECKOUT_TOKEN_ADDRESS_BY_NAME = {
  btc: '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh',
  openai: 'PreweJYECqtQwBtpxHL171nL2K6umo692gTm7Q3rpgF',
};

export const getCheckoutTokenAddress = (tokenName) => {
  if (!tokenName || typeof tokenName !== 'string') return null;
  return CHECKOUT_TOKEN_ADDRESS_BY_NAME[tokenName.toLowerCase()] ?? null;
};

export const CHECKOUT_RETURN_STORAGE_KEY = 'deks_checkout_return';
